<template>
  <div>
    <div style="width: 100%">
      <vs-col
        v-for="(zone, index) in polygons"
        :key="index"
        class="zone-cont"
        vs-w="4"
      >
        <div v-if="zone.feeId" class="zone" @click="selectZone(zone)">
          <p class="name">{{ zone.title }}</p>
        </div>
      </vs-col>
    </div>
  </div>
</template>

<script>
import providerApiService from "../../../../services/api/ProviderApiService";
import { isArray } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "ProviderZonesList",
  components: {},
  data() {
    return {
      polygons: [],
      providerDeliveryFees: [],
    };
  },
  computed: {
    propertyAAndPropertyB() {
      return `${JSON.stringify(this.polygons)}|${JSON.stringify(
        this.providerDeliveryFees
      )}`;
    },
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  watch: {
    propertyAAndPropertyB(newVal) {
      const [newPropertyA, newPropertyB] = newVal.split("|");
      const polygons = JSON.parse(newPropertyA);
      const providerDeliveryFees = JSON.parse(newPropertyB);
      if (
        polygons &&
        polygons.length > 0 &&
        providerDeliveryFees &&
        providerDeliveryFees.length > 0
      ) {
        this.polygons = polygons.map((item) => {
          let selected = item;
          providerDeliveryFees.forEach((element) => {
            if (item.id === element.zone) {
              selected = { ...item, feeId: element.id, fee: element.fee };
            }
          });

          return selected;
        });
      }
    },
  },
  methods: {
    getAllPolygons() {
      providerApiService.getAllMapPolygons().then((result) => {
        this.polygons = result.data;
        this.getProviderDeliveryFees();
      });
    },
    getProviderDeliveryFees() {
      providerApiService
        .getProviderDeliveryFees(this.currentProvider.id)
        .then((result) => {
          if (isArray(result.data) && result.data.length > 0) {
            this.providerDeliveryFees = result.data;
          }
        });
    },
    selectZone(zone) {
      this.$emit("selectZone", zone);
    },
  },
  mounted() {
    this.getAllPolygons();
  },
};
</script>

<style scoped lang="scss">
.zone-cont {
  margin: 0;
  padding: 0;
  float: left;

  .zone {
    position: relative;
    border-radius: 2px;
    margin: 1px;
    padding: 10px 10px;
    height: 45px;
    overflow: hidden;
    cursor: pointer;
    user-select: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: #e0e0e0;

    .name {
      font-size: 12px;
      font-weight: 700;
    }
  }
}
</style>
